var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
const useStyles = makeStyles({
    img: {
        objectFit: 'cover',
        cursor: 'pointer',
    },
    grid: {
        borderRadius: 12
    },
    tile: {
        overflow: 'hidden',
    },
    imgTile: {
        '&:after': {
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            pointerEvents: 'none',
            background: 'rgba(0,0,0,0)',
            transition: '.15s',
            content: '" "',
            position: 'absolute',
            display: 'block',
        },
        '&:hover:after': {
            background: 'rgba(0,0,0,30%)',
        },
    },
}, { name: 'ImageGrid' });
function Tile(props) {
    const { url, index, onClick } = props, tileProps = __rest(props, ["url", "index", "onClick"]);
    const classes = useStyles();
    const handleClick = useCallback(() => {
        if (props.onClick)
            props.onClick(index);
    }, [props.url, props.index, props.onClick]);
    return React.createElement(GridListTile, Object.assign({}, tileProps, { classes: { tile: `${classes.tile} ${classes.imgTile}` } }),
        React.createElement("img", { src: url, className: classes.img, onClick: handleClick }));
}
function SmallGrid(props) {
    const colWidth = 6;
    const { images: unboundImages, onClick } = props, gridProps = __rest(props, ["images", "onClick"]);
    const images = unboundImages.slice(0, 3);
    const classes = useStyles();
    return React.createElement(GridList, Object.assign({}, gridProps, { cols: colWidth, classes: { root: classes.grid } }), images.length > 0
        ? React.createElement(Tile, { url: images[0].urls.large, cols: colWidth, rows: 3, index: 0, onClick: onClick })
        : null);
}
function MediumGrid(props) {
    const colWidth = 4;
    const { images, onClick } = props, gridProps = __rest(props, ["images", "onClick"]);
    const classes = useStyles();
    return React.createElement(GridList, Object.assign({}, gridProps, { cols: colWidth, classes: { root: classes.grid } }),
        images.length > 0
            ? React.createElement(Tile, { cols: colWidth - 1, rows: 3, url: images[0].urls.large, index: 0, onClick: onClick })
            : null,
        React.createElement(GridListTile, { rows: 3, classes: { tile: classes.tile } },
            React.createElement(GridList, { cols: 1, cellHeight: gridProps.cellHeight, spacing: gridProps.spacing }, images.slice(1, 4).map((x, i) => React.createElement(Tile, { url: x.urls.thumbnail, index: i + 1, onClick: onClick, key: i })))));
}
export default function ImageGrid(props) {
    return (React.createElement("div", null,
        props.images.length <= 3
            ? React.createElement(SmallGrid, { images: props.images, cellHeight: props.cellHeight, spacing: props.spacing, onClick: props.onClick })
            : null,
        props.images.length > 3
            ? React.createElement(MediumGrid, { images: props.images, cellHeight: props.cellHeight, spacing: props.spacing, onClick: props.onClick })
            : null));
}
